import {Action, ID, ReduxEntity, ReduxList} from "app/types/app-types"
import {AlternativeTemplate, CustomPalette, Gradient, Palette, Template} from "app/types/model-types";
import {ApiRequest} from "app/types/api-types"
import { SizeItem } from "settings/components/sizes-settings";
import { GET_ALT_TEMPLATES, GET_ALT_TEMPLATES_LEVELS } from "template-list/types";
import { AlternativeTemplatesLevels } from '../app/types/model-types';

export const GET_CUSTOM_PALETTES: ApiRequest = {
    CREATE: "GET_COLLAGE_LAYOUTS_CREATE",
    STARTED: "GET_COLLAGE_LAYOUTS_STARTED",
    SUCCESS: "GET_COLLAGE_LAYOUTS_SUCCESS",
    ERROR: "GET_COLLAGE_LAYOUTS_ERROR",
}

export const GET_GRADIENTS: ApiRequest = {
    CREATE: "GET_GRADIENTS_CREATE",
    STARTED: "GET_GRADIENTS_STARTED",
    SUCCESS: "GET_GRADIENTS_SUCCESS",
    ERROR: "GET_GRADIENTS_ERROR",
}

export const GET_COLLAGE_LAYOUTS: ApiRequest = {
    CREATE: "GET_COLLAGE_LAYOUTS_CREATE",
    STARTED: "GET_COLLAGE_LAYOUTS_STARTED",
    SUCCESS: "GET_COLLAGE_LAYOUTS_SUCCESS",
    ERROR: "GET_COLLAGE_LAYOUTS_ERROR",
}

export const POST_RENDER_PREVIEW_IMAGE: ApiRequest = {
    CREATE: "POST_RENDER_PREVIEW_IMAGE_CREATE",
    STARTED: "POST_RENDER_PREVIEW_IMAGE_STARTED",
    SUCCESS: "POST_RENDER_PREVIEW_IMAGE_SUCCESS",
    ERROR: "POST_RENDER_PREVIEW_IMAGE_ERROR",
}

export const POST_TEMPLATE: ApiRequest = {
    CREATE: "POST_TEMPLATE_CREATE",
    STARTED: "POST_TEMPLATE_STARTED",
    SUCCESS: "POST_TEMPLATE_SUCCESS",
    ERROR: "POST_TEMPLATE_ERROR",
}

export const UPDATE_SETTINGS: ApiRequest = {
    CREATE: "UPDATE_SETTINGS_CREATE",
    STARTED: "UPDATE_SETTINGS_STARTED",
    SUCCESS: "UPDATE_SETTINGS_SUCCESS",
    ERROR: "UPDATE_SETTINGS_ERROR",
}

export const SAVE_SIZES: ApiRequest = {
    CREATE: "SAVE_SIZES_CREATE",
    STARTED: "SAVE_SIZES_STARTED",
    SUCCESS: "SAVE_SIZES_SUCCESS",
    ERROR: "SAVE_SIZES_ERROR",
}

export const POST_CUSTOM_IMAGE_SET_FILE: ApiRequest = {
    CREATE: "POST_CUSTOM_IMAGE_SET_FILE_CREATE",
    STARTED: "POST_CUSTOM_IMAGE_SET_FILE_STARTED",
    SUCCESS: "POST_CUSTOM_IMAGE_SET_FILE_SUCCESS",
    ERROR: "POST_CUSTOM_IMAGE_SET_FILE_ERROR",
}

export const DELETE_IMAGE_FROM_CUSTOM_SET: ApiRequest = {
    CREATE: 'DELETE_IMAGE_FROM_CUSTOM_SET_CREATE',
    STARTED: 'DELETE_IMAGE_FROM_CUSTOM_SET_STARTED',
    SUCCESS: 'DELETE_IMAGE_FROM_CUSTOM_SET_SUCCESS',
    ERROR: 'DELETE_IMAGE_FROM_CUSTOM_SET_ERROR',
}

export const DELETE_CUSTOM_IMAGE_SET: ApiRequest = {
    CREATE: 'DELETE_CUSTOM_IMAGE_SET_CREATE',
    STARTED: 'DELETE_CUSTOM_IMAGE_SET_STARTED',
    SUCCESS: 'DELETE_CUSTOM_IMAGE_SET_SUCCESS',
    ERROR: 'DELETE_CUSTOM_IMAGE_SET_ERROR',
}

export const SAVE_CUSTOM_IMAGE_SET: ApiRequest = {
    CREATE: "SAVE_CUSTOM_IMAGE_SET_CREATE",
    STARTED: "SAVE_CUSTOM_IMAGE_SET_STARTED",
    SUCCESS: "SAVE_CUSTOM_IMAGE_SET_SUCCESS",
    ERROR: "SAVE_CUSTOM_IMAGE_SET_ERROR",
}


export const UPLOAD_IMAGE_FILE: ApiRequest = {
    CREATE: "UPLOAD_IMAGE_FILE_CREATE",
    STARTED: "UPLOAD_IMAGE_FILE_STARTED",
    SUCCESS: "UPLOAD_IMAGE_FILE_SUCCESS",
    ERROR: "UPLOAD_IMAGE_FILE_ERROR",
}

export const IMPORT_JSON_TEMPLATE: ApiRequest = {
    CREATE: "IMPORT_JSON_TEMPLATE_CREATE",
    STARTED: "IMPORT_JSON_TEMPLATE_STARTED",
    SUCCESS: "IMPORT_JSON_TEMPLATE_SUCCESS",
    ERROR: "IMPORT_JSON_TEMPLATE_ERROR",
}

export const REORDER_TEMPLATES: ApiRequest = {
    CREATE: "REORDER_TEMPLATES_CREATE",
    STARTED: "REORDER_TEMPLATES_STARTED",
    SUCCESS: "REORDER_TEMPLATES_SUCCESS",
    ERROR: "REORDER_TEMPLATES_ERROR",
}

export const GENERAL_ERROR = 'GENERAL_ERROR'
export const GENERAL_SUCCESS = 'GENERAL_SUCCESS'
export const SAVED_OK = 'SAVED_OK'
export const TEMPLATE_NOT_FOUND = "TEMPLATE_NOT_FOUND"

export const DUPLICATE_TEMPLATE = 'DUPLICATE_TEMPLATE'
export const SET_TEMPLATES_TO_STORE = "SET_TEMPLATES_TO_STORE"
export const SET_TEMPLATE_IS_SAVING = "SET_TEMPLATE_IS_SAVING"
export const SET_PALETTES_TO_STORE = "SET_PALETTES_TO_STORE"
export const SET_GRADIENTS_TO_STORE = "SET_GRADIENTS_TO_STORE"
export const SET_DRAGGING = "SET_DRAGGING"
export const SET_IS_ALT = "SET_IS_ALT"
export const SET_BLOCK_NAVIGATION = "SET_BLOCK_NAVIGATION"

export const INVALID_FIELD_VALUE = "INVALID_FIELD_VALUE"
export const LAYER_COPIED = 'LAYER_COPIED'

export const SET_MISTAKE_BY_USER: ApiRequest = {
    CREATE: "SET_MISTAKE_BY_USER_CREATE",
    STARTED: "SET_MISTAKE_BY_USER_STARTED",
    SUCCESS: "SET_MISTAKE_BY_USER_SUCCESS",
    ERROR: "SET_MISTAKE_BY_USER_ERROR",
}

export const SAVE_COLLAGE_LAYOUTS: ApiRequest = {
    CREATE: "SAVE_COLLAGE_LAYOUTS_CREATE",
    STARTED: "SAVE_COLLAGE_LAYOUTS_STARTED",
    SUCCESS: "SAVE_COLLAGE_LAYOUTS_SUCCESS",
    ERROR: "SAVE_COLLAGE_LAYOUTS_ERROR",
}

export const CREATE_DEFAULT_COLLAGE_LAYOUTS: ApiRequest = {
    CREATE: "CREATE_DEFAULT_COLLAGE_LAYOUTS_CREATE",
    STARTED: "CREATE_DEFAULT_COLLAGE_LAYOUTS_STARTED",
    SUCCESS: "CREATE_DEFAULT_COLLAGE_LAYOUTS_SUCCESS",
    ERROR: "CREATE_DEFAULT_COLLAGE_LAYOUTS_ERROR",
}

export const DELETE_ALL_UNUSED_COLLAGE_LAYOUTS: ApiRequest = {
    CREATE: "DELETE_ALL_UNUSED_COLLAGE_LAYOUTS_CREATE",
    STARTED: "DELETE_ALL_UNUSED_COLLAGE_LAYOUTS_STARTED",
    SUCCESS: "DELETE_ALL_UNUSED_COLLAGE_LAYOUTS_SUCCESS",
    ERROR: "DELETE_ALL_UNUSED_COLLAGE_LAYOUTS_ERROR",
}

export const SAVE_COLLAGE_LAYOUT: ApiRequest = {
    CREATE: "SAVE_COLLAGE_LAYOUT_CREATE",
    STARTED: "SAVE_COLLAGE_LAYOUT_STARTED",
    SUCCESS: "SAVE_COLLAGE_LAYOUT_SUCCESS",
    ERROR: "SAVE_COLLAGE_LAYOUT_ERROR",
}

export const SAVE_SETTINGS_ORDER: ApiRequest = {
    CREATE: "SAVE_SETTINGS_ORDER_CREATE",
    STARTED: "SAVE_SETTINGS_ORDER_STARTED",
    SUCCESS: "SAVE_SETTINGS_ORDER_SUCCESS",
    ERROR: "SAVE_SETTINGS_ORDER_ERROR",
}

export const DELETE_COLLAGE_LAYOUTS: ApiRequest = {
    CREATE: "DELETE_COLLAGE_LAYOUTS_CREATE",
    STARTED: "DELETE_COLLAGE_LAYOUTS_STARTED",
    SUCCESS: "DELETE_COLLAGE_LAYOUTS_SUCCESS",
    ERROR: "DELETE_COLLAGE_LAYOUTS_ERROR",
}

export const DELETE_COLLAGE_LAYOUT_IMAGE: ApiRequest = {
    CREATE: "DELETE_COLLAGE_LAYOUT_IMAGE_CREATE",
    STARTED: "DELETE_COLLAGE_LAYOUT_IMAGE_STARTED",
    SUCCESS: "DELETE_COLLAGE_LAYOUT_IMAGE_SUCCESS",
    ERROR: "DELETE_COLLAGE_LAYOUT_IMAGE_ERROR",
}

export const ADD_COLLAGE_LAYOUT: ApiRequest = {
    CREATE: "ADD_COLLAGE_LAYOUT_CREATE",
    STARTED: "ADD_COLLAGE_LAYOUT_STARTED",
    SUCCESS: "ADD_COLLAGE_LAYOUT_SUCCESS",
    ERROR: "ADD_COLLAGE_LAYOUT_ERROR",
}

export const ADD_COLLAGE_LAYOUT_IMAGE: ApiRequest = {
    CREATE: "ADD_COLLAGE_LAYOUT_IMAGE_CREATE",
    STARTED: "ADD_COLLAGE_LAYOUT_IMAGE_STARTED",
    SUCCESS: "ADD_COLLAGE_LAYOUT_IMAGE_SUCCESS",
    ERROR: "ADD_COLLAGE_LAYOUT_IMAGE_ERROR",
}
export const SET_WATERMARK_BY_USER: ApiRequest = {
    CREATE: "SET_WATERMARK_BY_USER_CREATE",
    STARTED: "SET_WATERMARK_BY_USER_STARTED",
    SUCCESS: "SET_WATERMARK_BY_USER_SUCCESS",
    ERROR: "SET_WATERMARK_BY_USER_ERROR",
}

export const SET_QUALITY_BY_USER: ApiRequest = {
    CREATE: "SET_QUALITY_BY_USER_CREATE",
    STARTED: "SET_QUALITY_BY_USER_STARTED",
    SUCCESS: "SET_QUALITY_BY_USER_SUCCESS",
    ERROR: "SET_QUALITY_BY_USER_ERROR",
}

export const SET_TEMPLATE_ACTIVE_DATE: ApiRequest = {
    CREATE: "SET_TEMPLATE_ACTIVE_DATE_CREATE",
    STARTED: "SET_TEMPLATE_ACTIVE_DATE_STARTED",
    SUCCESS: "SET_TEMPLATE_ACTIVE_DATE_SUCCESS",
    ERROR: "SET_TEMPLATE_ACTIVE_DATE_ERROR",
}

export type Templates = {
    data: Array<Template> | any
    isLoading: boolean
    isLoaded: boolean
    isSaving: boolean
    error: string | Error
    updated: Date
    atLeastOneActive: boolean
}

export type AltTemplatesReduxList = {
    data: Array<AlternativeTemplate|AlternativeTemplatesLevels> | any
    isLoading: boolean
    isLoaded: boolean
    isSaving: boolean
    error: string | Error
    updated: Date
}

const defaultTemplatesState: Templates = {
    data: [],
    isLoaded: false,
    isLoading: false,
    isSaving: false,
    error: null,
    updated: null,
    atLeastOneActive: true,
}

const defaultAlternativeTemplatesState: AltTemplatesReduxList = {
    data: [],
    isLoaded: false,
    isLoading: false,
    isSaving: false,
    error: null,
    updated: null,
}

const defaultAlternativeTemplatesLevelsState: AltTemplatesReduxList = {
    data: [],
    isLoaded: false,
    isLoading: false,
    isSaving: false,
    error: null,
    updated: null,
}

export function templatesReducer(state: Templates = defaultTemplatesState, action: Action<any>): Templates {
    switch (action.type) {
        case REORDER_TEMPLATES.STARTED:
            return {...state, data: [...action.payload], isSaving: true}
        case REORDER_TEMPLATES.SUCCESS:
        case SET_TEMPLATES_TO_STORE:
        case POST_TEMPLATE.SUCCESS:
            const activeTemplates = action.payload.filter(template => {
                if (template.active) return true
            })
            return {...state, data: [...action.payload], isLoaded: true, isLoading: false, isSaving: false, atLeastOneActive: activeTemplates.length > 0 }
        case SET_TEMPLATE_IS_SAVING:
            return {...state, isSaving: action.payload}
        default:
            return state
    }
}

export function alternativeTemplatesReducer(state: AltTemplatesReduxList = defaultAlternativeTemplatesState, action: Action<AltTemplatesReduxList>): AltTemplatesReduxList {
    switch (action.type) {
        case GET_ALT_TEMPLATES.STARTED:
            return {...state, ...{isLoading: true}}
        case GET_ALT_TEMPLATES.SUCCESS:
            return {...state, ...{isLoaded: true, isLoading: false, data: action.payload}}
        case GET_ALT_TEMPLATES.ERROR:
            return {...state, ...{isLoading: false, isLoaded: false, error: action.error}}
        default:
            return state
    }
}

export function alternativeTemplatesLevelsReducer(state: AltTemplatesReduxList = defaultAlternativeTemplatesLevelsState, action: Action<AltTemplatesReduxList>): AltTemplatesReduxList {
    switch (action.type) {
        case GET_ALT_TEMPLATES_LEVELS.STARTED:
            return {...state, ...{isLoading: true}}
        case GET_ALT_TEMPLATES_LEVELS.SUCCESS:
            return {...state, ...{isLoaded: true, isLoading: false, data: action.payload}}
        case GET_ALT_TEMPLATES_LEVELS.ERROR:
            return {...state, ...{isLoading: false, isLoaded: false, error: action.error}}
        default:
            return state
    }
}

export function palettesReducer(state: Palette[] = null, action: Action<any>): Palette[] {
    switch (action.type) {
        case SET_PALETTES_TO_STORE:
            return action.payload   //is loading is loaded?
        default:
            return state
    }
}

export function gradientsReducer(state: Gradient[] = null, action: Action<any>): Gradient[] {
    switch (action.type) {
        case SET_GRADIENTS_TO_STORE:
            return action.payload   //is loading is loaded?
        default:
            return state
    }
}

export function isDraggingReducer(state: boolean = false, action: Action<any>): boolean {
    if (action.type === SET_DRAGGING) {
        return action.payload
    } else {
        return state
    }
}

export function isAltReducer(state: boolean = false, action: Action<any>): boolean {
    if (action.type === SET_IS_ALT) {
        return action.payload
    } else {
        return state
    }
}

export function blockNavigationReducer(state: boolean = false, action: Action<any>): boolean {
    if (action.type === SET_BLOCK_NAVIGATION) {
        return action.payload
    } else {
        return state
    }
}

//actions:

export function orderedBySize(state: Templates): Array<Template> {
    return state.data
}

//order is an array of ids in new order
export function reorderTemplates(order: Array<ID>, templates: Templates) {
    return {
        type: REORDER_TEMPLATES.CREATE,
        payload: {
            order,
            templates
        }
    }
}

export function setTemplatesToStore(templates: Template[]): Action<Template[]> {
    return {
        type: SET_TEMPLATES_TO_STORE,
        payload: templates
    }
}

export function setAlternativeTemplatesToStore(alternativeTemplates: AlternativeTemplate[]): Action<AlternativeTemplate[]> {
    return {
        type: GET_ALT_TEMPLATES.SUCCESS,
        payload: alternativeTemplates
    }
}

export function setAlternativeTemplatesLevelsToStore(levels: AlternativeTemplatesLevels[]): Action<AlternativeTemplatesLevels[]> {
    return {
        type: GET_ALT_TEMPLATES_LEVELS.SUCCESS,
        payload: levels
    }
}

export function setIsLoadingAlternativeTemplates(): Action<boolean> {
    return {
        type: GET_ALT_TEMPLATES.STARTED,
    }
}

export function setPalettesToStore(palettes: Palette[]): Action<Palette[]> {
    return {
        type: SET_PALETTES_TO_STORE,
        payload: palettes,
    }
}

export function setGradientsToStore(gradients: Gradient[]): Action<Gradient[]> {
    return {
        type: SET_GRADIENTS_TO_STORE,
        payload: gradients,
    }
}

export function setSavingTemplate(state: boolean): Action<boolean> {
    return {
        type: SET_TEMPLATE_IS_SAVING,
        payload: state
    }
}

export function setDragging(state: boolean): Action<boolean> {
    return {
        type: SET_DRAGGING,
        payload: state,
    }
}

export function setIsAlt(state: boolean): Action<boolean> {
    return {
        type: SET_IS_ALT,
        payload: state,
    }
}

export function setBlockNavigation(blockNavigation: boolean): Action<boolean> {
    if (blockNavigation) {
        window.onbeforeunload = () => true
    } else {
        window.onbeforeunload = undefined
    }

    return {
        type: SET_BLOCK_NAVIGATION,
        payload: blockNavigation
    }
}

export const GET_SIZES: ApiRequest = {
    CREATE: "GET_SIZES_CREATE",
    STARTED: "GET_SIZES_STARTED",
    SUCCESS: "GET_SIZES_SUCCESS",
    ERROR: "GET_SIZES_ERROR",
}

export type SizesState = ReduxEntity<SizeItem>
export function setSizesToStore(data: SizeItem[]): Action<SizeItem[]> {
    return {
        type: GET_SIZES.SUCCESS,
        payload: data
    }
}

const defaultSizesState : ReduxList<SizeItem> = {
    data: [],
    isLoaded: false,
    isLoading: false,
    error: null,
    updated: null,
}

export function sizesReducer(state: ReduxList<SizeItem> = defaultSizesState, action): ReduxList<SizeItem> {
    switch (action.type) {
        case GET_SIZES.STARTED:
            return {...state, ...{isLoading: true}}
        case GET_SIZES.SUCCESS:
            return {...state, ...{isLoaded: true, isLoading: false, data: action.payload}}
        case GET_SIZES.ERROR:
            return {...state, ...{isLoading: false, isLoaded: false, error: action.error}}
        default:
            return state
    }
}
